import config from "./config";
import axios from "axios";

const filesFromFolder = async (folder, getDirectory) => {
  const args = {
    Prefix: folder,
    // if getDirectory is true, StartAfter key is omitted
    StartAfter: getDirectory ? folder : null,
  };

  const obj = {
    command: "listObjectsV2",
    args,
  };

  const [url, params] = await config("listObjectsV2", args);

  return await axios.post(url, params).then((res) => {
    if (res.data.Contents) {
      return res.data.Contents.map((i) => i.Key);
    } else {
      return [];
    }
  });
};

export default filesFromFolder;
